export interface CountryData {
  label: string
  currency: { name: string; symbol: string }
}

export const countries: CountryData[] = [
  { label: 'United States', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Canada', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Australia', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'New Zealand', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'United Kingdom', currency: { name: 'Pound', symbol: '£' } },
  { label: 'Afghanistan', currency: { name: 'Afghani', symbol: '؋' } },
  { label: 'Åland Islands', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Albania', currency: { name: 'Lek', symbol: 'L' } },
  { label: 'Algeria', currency: { name: 'Dinar', symbol: 'دج' } },
  { label: 'American Samoa', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Andorra', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Angola', currency: { name: 'Kwanza', symbol: 'Kz' } },
  { label: 'Anguilla', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Antigua and Barbuda', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Argentina', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Armenia', currency: { name: 'Dram', symbol: '֏' } },
  { label: 'Aruba', currency: { name: 'Florin', symbol: 'ƒ' } },
  { label: 'Austria', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Azerbaijan', currency: { name: 'Manat', symbol: '₼' } },
  { label: 'Bahamas', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Bahrain', currency: { name: 'Dinar', symbol: 'BD' } },
  { label: 'Bangladesh', currency: { name: 'Taka', symbol: '৳' } },
  { label: 'Barbados', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Belarus', currency: { name: 'Ruble', symbol: 'Br' } },
  { label: 'Belgium', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Belize', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Benin', currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Bermuda', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Bhutan', currency: { name: 'Ngultrum', symbol: 'Nu' } },
  { label: 'Bolivia', currency: { name: 'Boliviano', symbol: 'Bs' } },
  { label: 'Bosnia and Herzegovina', currency: { name: 'Marka', symbol: 'KM' } },
  { label: 'Botswana', currency: { name: 'Pula', symbol: 'P' } },
  { label: 'Brazil', currency: { name: 'Real', symbol: 'R$' } },
  { label: 'Brunei Darussalam', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Bulgaria', currency: { name: 'Lev', symbol: 'лв' } },
  { label: 'Burkina Faso', currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Burundi', currency: { name: 'Franc', symbol: 'Fr' } },
  { label: 'Cambodia', currency: { name: 'Riel', symbol: '៛' } },
  { label: 'Cameroon', currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Cape Verde', currency: { name: 'Escudo', symbol: '$' } },
  { label: 'Cayman Islands', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Central African Republic', currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Chad', currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Chile', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'China', currency: { name: 'Yuan', symbol: '¥' } },
  { label: 'Colombia', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Comoros', currency: { name: 'Franc', symbol: 'Fr' } },
  { label: 'Congo', currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Congo, The Democratic Republic of the', currency: { name: 'Franc', symbol: 'Fr' } },
  { label: 'Cook Islands', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Costa Rica', currency: { name: 'Colón', symbol: '₡' } },
  { label: "Cote D'Ivoire", currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Croatia', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Cuba', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Cyprus', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Czech Republic', currency: { name: 'Koruna', symbol: 'Kč' } },
  { label: 'Denmark', currency: { name: 'Krone', symbol: 'kr' } },
  { label: 'Djibouti', currency: { name: 'Franc', symbol: 'Fr' } },
  { label: 'Dominica', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Dominican Republic', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Ecuador', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Egypt', currency: { name: 'Pound', symbol: '£' } },
  { label: 'El Salvador', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Equatorial Guinea', currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Eritrea', currency: { name: 'Nakfa', symbol: 'Nfk' } },
  { label: 'Estonia', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Ethiopia', currency: { name: 'Birr', symbol: 'Br' } },
  { label: 'Falkland Islands (Malvinas)', currency: { name: 'Pound', symbol: '£' } },
  { label: 'Faroe Islands', currency: { name: 'Krone', symbol: 'kr' } },
  { label: 'Fiji', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Finland', currency: { name: 'Euro', symbol: '€' } },
  { label: 'France', currency: { name: 'Euro', symbol: '€' } },
  { label: 'French Guiana', currency: { name: 'Euro', symbol: '€' } },
  { label: 'French Polynesia', currency: { name: 'Franc', symbol: 'Fr' } },
  { label: 'Gabon', currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Gambia', currency: { name: 'Dalasi', symbol: 'D' } },
  { label: 'Georgia', currency: { name: 'Lari', symbol: '₾' } },
  { label: 'Germany', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Ghana', currency: { name: 'Cedi', symbol: '₵' } },
  { label: 'Gibraltar', currency: { name: 'Pound', symbol: '£' } },
  { label: 'Greece', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Greenland', currency: { name: 'Krone', symbol: 'kr' } },
  { label: 'Grenada', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Guadeloupe', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Guam', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Guatemala', currency: { name: 'Quetzal', symbol: 'Q' } },
  { label: 'Guernsey', currency: { name: 'Pound', symbol: '£' } },
  { label: 'Guinea', currency: { name: 'Franc', symbol: 'Fr' } },
  { label: 'Guinea-Bissau', currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Guyana', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Haiti', currency: { name: 'Gourde', symbol: 'G' } },
  { label: 'Vatican City', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Honduras', currency: { name: 'Lempira', symbol: 'L' } },
  { label: 'Hong Kong', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Hungary', currency: { name: 'Forint', symbol: 'Ft' } },
  { label: 'Iceland', currency: { name: 'Krone', symbol: 'kr' } },
  { label: 'India', currency: { name: 'Rupee', symbol: '₹' } },
  { label: 'Indonesia', currency: { name: 'Rupiah', symbol: 'Rp' } },
  { label: 'Iran', currency: { name: 'Rial', symbol: '﷼' } },
  { label: 'Iraq', currency: { name: 'Dinar', symbol: 'ع.د' } },
  { label: 'Ireland', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Isle of Man', currency: { name: 'Pound', symbol: '£' } },
  { label: 'Israel', currency: { name: 'Shekel', symbol: '₪' } },
  { label: 'Italy', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Jamaica', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Japan', currency: { name: 'Yen', symbol: '¥' } },
  { label: 'Jersey', currency: { name: 'Pound', symbol: '£' } },
  { label: 'Jordan', currency: { name: 'Dinar', symbol: 'JD' } },
  { label: 'Kazakhstan', currency: { name: 'Tenge', symbol: '₸' } },
  { label: 'Kenya', currency: { name: 'Shilling', symbol: 'KSh' } },
  { label: 'Kiribati', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'North Korea', currency: { name: 'Won', symbol: '₩' } },
  { label: 'South Korea', currency: { name: 'Won', symbol: '₩' } },
  { label: 'Kuwait', currency: { name: 'Dinar', symbol: 'KD' } },
  { label: 'Kyrgyzstan', currency: { name: 'Som', symbol: 'с' } },
  { label: 'Laos', currency: { name: 'Kip', symbol: '₭' } },
  { label: 'Latvia', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Lebanon', currency: { name: 'Pound', symbol: '£' } },
  { label: 'Lesotho', currency: { name: 'Loti', symbol: 'L' } },
  { label: 'Liberia', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Libya', currency: { name: 'Dinar', symbol: 'LD' } },
  { label: 'Liechtenstein', currency: { name: 'Franc', symbol: 'Fr' } },
  { label: 'Lithuania', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Luxembourg', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Macao', currency: { name: 'Pataca', symbol: 'P' } },
  { label: 'North Macedonia', currency: { name: 'Denar', symbol: 'ден' } },
  { label: 'Madagascar', currency: { name: 'Ariary', symbol: 'Ar' } },
  { label: 'Malawi', currency: { name: 'Kwacha', symbol: 'MK' } },
  { label: 'Malaysia', currency: { name: 'Ringgit', symbol: 'RM' } },
  { label: 'Maldives', currency: { name: 'Rufiyaa', symbol: 'Rf' } },
  { label: 'Mali', currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Malta', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Marshall Islands', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Martinique', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Mauritania', currency: { name: 'Ouguiya', symbol: 'UM' } },
  { label: 'Mauritius', currency: { name: 'Rupee', symbol: '₹' } },
  { label: 'Mayotte', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Mexico', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Moldova', currency: { name: 'Leu', symbol: 'L' } },
  { label: 'Monaco', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Mongolia', currency: { name: 'Tögrög', symbol: '₮' } },
  { label: 'Montserrat', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Morocco', currency: { name: 'Dirham', symbol: 'MAD' } },
  { label: 'Mozambique', currency: { name: 'Metical', symbol: 'MT' } },
  { label: 'Myanmar', currency: { name: 'Kyat', symbol: 'K' } },
  { label: 'Namibia', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Nauru', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Nepal', currency: { name: 'Rupee', symbol: '₹' } },
  { label: 'Netherlands', currency: { name: 'Euro', symbol: '€' } },
  { label: 'New Caledonia', currency: { name: 'Franc', symbol: 'Fr' } },
  { label: 'Nicaragua', currency: { name: 'Córdoba', symbol: 'C$' } },
  { label: 'Niger', currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Nigeria', currency: { name: 'Naira', symbol: '₦' } },
  { label: 'Northern Mariana Islands', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Norway', currency: { name: 'Krone', symbol: 'kr' } },
  { label: 'Oman', currency: { name: 'Rial', symbol: '﷼' } },
  { label: 'Pakistan', currency: { name: 'Rupee', symbol: '₹' } },
  { label: 'Palau', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Palestine', currency: { name: 'Shekel', symbol: '₪' } },
  { label: 'Panama', currency: { name: 'Balboa', symbol: 'B/.' } },
  { label: 'Papua New Guinea', currency: { name: 'Kina', symbol: 'K' } },
  { label: 'Paraguay', currency: { name: 'Guaraní', symbol: '₲' } },
  { label: 'Peru', currency: { name: 'Sol', symbol: 'S/' } },
  { label: 'Philippines', currency: { name: 'Philippine Peso', symbol: '₱' } },
  { label: 'Poland', currency: { name: 'Złoty', symbol: 'zł' } },
  { label: 'Portugal', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Puerto Rico', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Qatar', currency: { name: 'Riyal', symbol: 'ر.ق' } },
  { label: 'Romania', currency: { name: 'Leu', symbol: 'lei' } },
  { label: 'Russia', currency: { name: 'Ruble', symbol: '₽' } },
  { label: 'Rwanda', currency: { name: 'Franc', symbol: 'Fr' } },
  { label: 'Saint Helena', currency: { name: 'Pound', symbol: '£' } },
  { label: 'Saint Kitts and Nevis', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Saint Lucia', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Saint Pierre and Miquelon', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Saint Vincent and the Grenadines', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Samoa', currency: { name: 'Tālā', symbol: 'T' } },
  { label: 'San Marino', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Sao Tome and Principe', currency: { name: 'Dobra', symbol: 'Db' } },
  { label: 'Saudi Arabia', currency: { name: 'Riyal', symbol: 'ر.س' } },
  { label: 'Senegal', currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Montenegro', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Serbia', currency: { name: 'Dinar', symbol: 'din' } },
  { label: 'Seychelles', currency: { name: 'Rupee', symbol: '₹' } },
  { label: 'Sierra Leone', currency: { name: 'Leone', symbol: 'Le' } },
  { label: 'Singapore', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Slovakia', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Slovenia', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Solomon Islands', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Somalia', currency: { name: 'Shilling', symbol: 'Sh' } },
  { label: 'South Africa', currency: { name: 'Rand', symbol: 'R' } },
  { label: 'Spain', currency: { name: 'Euro', symbol: '€' } },
  { label: 'Sri Lanka', currency: { name: 'Rupee', symbol: '₹' } },
  { label: 'Sudan', currency: { name: 'Pound', symbol: '£' } },
  { label: 'Suriname', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Eswatini', currency: { name: 'Lilangeni', symbol: 'L' } },
  { label: 'Sweden', currency: { name: 'Krona', symbol: 'kr' } },
  { label: 'Switzerland', currency: { name: 'Franc', symbol: 'Fr' } },
  { label: 'Syria', currency: { name: 'Pound', symbol: '£' } },
  { label: 'Taiwan', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Tajikistan', currency: { name: 'Somoni', symbol: 'SM' } },
  { label: 'Tanzania', currency: { name: 'Shilling', symbol: 'Sh' } },
  { label: 'Thailand', currency: { name: 'Baht', symbol: '฿' } },
  { label: 'Timor-Leste', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Togo', currency: { name: 'CFA Franc', symbol: 'Fr' } },
  { label: 'Tonga', currency: { name: "Pa'anga", symbol: 'T$' } },
  { label: 'Trinidad and Tobago', currency: { name: 'Trinidad and Tobago Dollar', symbol: 'TT$' } },
  { label: 'Tunisia', currency: { name: 'Dinar', symbol: 'DT' } },
  { label: 'Turkey', currency: { name: 'Lira', symbol: '₺' } },
  { label: 'Turkmenistan', currency: { name: 'Manat', symbol: 'T' } },
  { label: 'Turks and Caicos Islands', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Tuvalu', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Uganda', currency: { name: 'Shilling', symbol: 'Sh' } },
  { label: 'Ukraine', currency: { name: 'Hryvnia', symbol: '₴' } },
  { label: 'United Arab Emirates', currency: { name: 'Dirham', symbol: 'د.إ' } },
  { label: 'Uruguay', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Uzbekistan', currency: { name: 'Som', symbol: 'с' } },
  { label: 'Vanuatu', currency: { name: 'Vatu', symbol: 'Vt' } },
  { label: 'Venezuela', currency: { name: 'Bolívar', symbol: 'Bs.S' } },
  { label: 'Vietnam', currency: { name: 'Dong', symbol: '₫' } },
  { label: 'Virgin Islands, British', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Virgin Islands, U.S.', currency: { name: 'Dollar', symbol: '$' } },
  { label: 'Wallis and Futuna', currency: { name: 'Franc', symbol: 'Fr' } },
  { label: 'Western Sahara', currency: { name: 'Dirham', symbol: 'MAD' } },
  { label: 'Yemen', currency: { name: 'Rial', symbol: '﷼' } },
  { label: 'Zambia', currency: { name: 'Kwacha', symbol: 'ZK' } },
  { label: 'Zimbabwe', currency: { name: 'Dollar', symbol: '$' } }
]

export const COUNTRY_OPTIONS: { label: string; value: string }[] = countries.map(({ label }) => ({
  label,
  value: label
}))

export const COUNTRY_CURRENCY_MAP: Record<string, { name: string; symbol: string }> = Object.fromEntries(
  countries.map((c) => [c.label, c.currency])
)

const _currencyFirstOccurrenceIndex = new Map<string, number>()
countries.forEach((c, i) => {
  if (!_currencyFirstOccurrenceIndex.has(c.currency.name)) {
    _currencyFirstOccurrenceIndex.set(c.currency.name, i)
  }
})

export const CURRENCY_OPTIONS: { label: string; value: string }[] = Array.from(
  new Map(countries.map((c) => [c.currency.name, c.currency])).values()
)
  .sort((a, b) => {
    const aIdx = _currencyFirstOccurrenceIndex.get(a.name) ?? Infinity
    const bIdx = _currencyFirstOccurrenceIndex.get(b.name) ?? Infinity
    const FEATURED_CUTOFF = 5
    const aFeatured = aIdx < FEATURED_CUTOFF
    const bFeatured = bIdx < FEATURED_CUTOFF
    if (aFeatured && bFeatured) return aIdx - bIdx
    if (aFeatured) return -1
    if (bFeatured) return 1
    return a.name.localeCompare(b.name)
  })
  .map(({ name, symbol }) => ({ label: `${name} (${symbol})`, value: name }))
